<template>
  <el-input type="password"
    ref="input"
    v-model="model"
    :placeholder="placeholder"
    :clearable="clearable"
    :disabled="computedDisabled"
    :class="optionClass"
    :show-password="showPassword"
    @keydown.enter.native="onEnterKey($event)"
    @focus="onFocus"
    @blur="onBlur"
    @change="onChange"
    @clear="onClear"></el-input>
</template>

<script>
/* eslint-disable semi */
import { Component } from 'vue-property-decorator';
import AppInputComponent from './AppInputComponent';

@Component
export default class AppInputPassword extends AppInputComponent {
  // パスワード入力表示機能
  // 一部の機能（ログイン時等）でのみ有効
  get showPassword () {
    return this.options && this.options['show-password'];
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/input/AppInputPassword.vue